export const sidebarLocalStorageKeys = {
  documentSidebarWidth: 'document-sidebar-width',
  repoSideBarWidth: 'repo-sidebar-width',
  repoNavWidth: 'repo-nav-width',
}
